import { render } from "./ValidationPassRateMatrixTable.vue?vue&type=template&id=67a2a64d&scoped=true"
import script from "./ValidationPassRateMatrixTable.vue?vue&type=script&lang=js"
export * from "./ValidationPassRateMatrixTable.vue?vue&type=script&lang=js"

import "./ValidationPassRateMatrixTable.vue?vue&type=style&index=0&id=67a2a64d&scoped=true&lang=css"
import "./ValidationPassRateMatrixTable.vue?vue&type=style&index=1&id=67a2a64d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a2a64d"]])

export default __exports__